exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll ul{height:400px;width:100%;overflow:hidden;overflow-y:scroll}.permisos ul{height:100px;width:100%;overflow:hidden;overflow-y:scroll}", ""]);

// exports
